import React from "react";
import {useDispatch, useSelector} from 'react-redux';

import {Pagination} from '../../components/index';
import {CorsoDettaglioContainer} from '../CorsoDettaglio/CorsoDettaglioContainer';
import {FormSearchCorsi} from "./FormSearchCorsi";

import * as _ from 'lodash';
import {getNumeroRecordPerPagina, getPageRangeDisplayed} from "./utilityFunctionCorsi/utilityFunctionCorsi";
import {notifsActions} from "../../actions";
import {corsoCorsiActions} from '../../slices/corso_corsiSlice'
import { isPwa } from "../../fanctionUtility";


const Corsi = () => {

    const [activePage, setActivePage] = React.useState(1);
    const formSearchCorsiRef = React.useRef(null);

    const corsi = useSelector(state => state.corso.corsi);

    const dispatch = useDispatch();
    const initCorsi = React.useCallback(() => dispatch(corsoCorsiActions.initCorsi()), [dispatch]);
    const notifClear = React.useCallback(() => dispatch(notifsActions.notifClear()), [dispatch]);

    const numeroRecordPerPagina = getNumeroRecordPerPagina();
    const pageRangeDisplayed = getPageRangeDisplayed();

    React.useEffect(() => {
        return () => {
            initCorsi();
            notifClear();
        }
    }, [notifClear, initCorsi]);

    React.useEffect(() => {
        if (!_.isEmpty(corsi)) {
            window.scrollTo({top: 0, behavior: "smooth"});
        }
    }, [
        corsi
    ]);

    return (
        <div>

            <div style={{display: isPwa() ? 'none' : 'block'}} className='card mb-3 shadowCustom'>
                <div className="card-header">
                    <h3>Ricerca</h3>
                </div>
                <div className="card-body">
                    <FormSearchCorsi ref={formSearchCorsiRef}
                                     changeActivePage={(pageNumber) => setActivePage(pageNumber)}/>
                </div>
            </div>

            {!_.isEmpty(corsi) && corsi.responses.map(c => <CorsoDettaglioContainer key={c.id}
                                                                                    dati={c}/>)}

            {(!_.isEmpty(corsi)) && (
                <div className='d-flex flex-wrap justify-content-center align-items-center my-3'>
                    <Pagination
                        activePage={activePage}
                        itemsCountPerPage={numeroRecordPerPagina}
                        totalItemsCount={corsi.totalCount}
                        recordTotali={corsi.totalCount}
                        pagineTotali={Math.ceil(+corsi.totalCount / numeroRecordPerPagina)}
                        hideNavigation={corsi.totalCount / numeroRecordPerPagina < 1}
                        hideFirstLastPages={corsi.totalCount / numeroRecordPerPagina > 1 && corsi.totalCount / numeroRecordPerPagina <= pageRangeDisplayed}
                        hideDisabled={activePage === 1 || activePage === corsi.totalCount / numeroRecordPerPagina}
                        pageRangeDisplayed={pageRangeDisplayed}
                        onChange={formSearchCorsiRef.current != null ? formSearchCorsiRef.current.searchCorsi : null}
                    />
                </div>
            )}

            {isPwa() && <div className="mb-5">&nbsp;</div>}
        </div>
    )
}


export default Corsi;
